import { Routes, Route, Navigate } from "react-router-dom";
import { SignedIn, SignedOut, RedirectToSignIn } from "@clerk/clerk-react";
import { lazy, Suspense } from "react";
import { Box, Spinner } from "@radix-ui/themes";
import { AppShell } from "./components/app-shell";

const LandingPage = lazy(() => import("./routes/landing"));
const SignInPage = lazy(() => import("./routes/sign-in"));
const OnboardingPage = lazy(() => import("./routes/onboarding"));
const TryPathChooserPage = lazy(() => import("./routes/try"));
const TryPathAPage = lazy(() => import("./routes/try-path-a"));
const TryPathBPage = lazy(() => import("./routes/try-path-b"));
const TryResultPage = lazy(() => import("./routes/try-result"));
const BerandaPage = lazy(() => import("./routes/beranda"));
const UtangPage = lazy(() => import("./routes/utang"));
const UtangTambahPage = lazy(() => import("./routes/utang-tambah"));
const UtangDetailPage = lazy(() => import("./routes/utang-detail"));
const UtangStrategiPage = lazy(() => import("./routes/utang-strategi"));
const CashflowPage = lazy(() => import("./routes/cashflow"));
const CashflowRencanaPage = lazy(() => import("./routes/cashflow-rencana"));
const UploadPage = lazy(() => import("./routes/upload"));
const UploadReviewPage = lazy(() => import("./routes/upload-review"));
const BelajarPage = lazy(() => import("./routes/belajar"));
const ProfilPage = lazy(() => import("./routes/profil"));

function PageFallback() {
  return (
    <Box style={{ display: "flex", justifyContent: "center", padding: "64px 0" }}>
      <Spinner size="3" />
    </Box>
  );
}

function RequireAuth({ children }: { children: React.ReactNode }) {
  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <RedirectToSignIn />
      </SignedOut>
    </>
  );
}

export default function App() {
  return (
    <Suspense fallback={<PageFallback />}>
      <Routes>
        {/* Public */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/sign-in/*" element={<SignInPage />} />
        <Route path="/try" element={<TryPathChooserPage />} />
        <Route path="/try/path-a" element={<TryPathAPage />} />
        <Route path="/try/path-b" element={<TryPathBPage />} />
        <Route path="/try/result" element={<TryResultPage />} />

        {/* Authed */}
        <Route
          path="/onboarding"
          element={
            <RequireAuth>
              <OnboardingPage />
            </RequireAuth>
          }
        />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/beranda" element={<BerandaPage />} />
          <Route path="/utang" element={<UtangPage />} />
          <Route path="/utang/tambah" element={<UtangTambahPage />} />
          <Route path="/utang/strategi" element={<UtangStrategiPage />} />
          <Route path="/utang/:id" element={<UtangDetailPage />} />
          <Route path="/cashflow" element={<CashflowPage />} />
          <Route path="/cashflow/rencana" element={<CashflowRencanaPage />} />
          <Route path="/belajar" element={<BelajarPage />} />
          <Route path="/profil" element={<ProfilPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/upload/review/:id" element={<UploadReviewPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
}
